const Wishlist = {
  storageKey: 'shopify_custom_wishlist',
  
  getItems: function() {
    return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
  },
  
  saveItems: function(items) {
    localStorage.setItem(this.storageKey, JSON.stringify(items));
  },
  
  hasItem: function(handle) {
    return this.getItems().includes(handle);
  },
  
  addItem: function(handle) {
    const items = this.getItems();
    if (!items.includes(handle)) {
      items.push(handle);
      this.saveItems(items);
    }
  },
  
  removeItem: function(handle) {
    let items = this.getItems();
    items = items.filter(item => item !== handle);
    this.saveItems(items);
  },
  
  toggleItem: function(handle) {
    if (this.hasItem(handle)) {
      this.removeItem(handle);
      return false;
    } else {
      this.addItem(handle);
      return true;
    }
  },

  updateButtons: function() {
    const buttons = document.querySelectorAll('.js-wishlist-btn');
    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (this.hasItem(handle)) {
        btn.classList.add('is-active');
        if (btn.hasAttribute('data-active-text')) {
          const span = btn.querySelector('span');
          if (span) span.innerText = btn.getAttribute('data-active-text');
        }
      } else {
        btn.classList.remove('is-active');
        if (btn.hasAttribute('data-default-text')) {
          const span = btn.querySelector('span');
          if (span) span.innerText = btn.getAttribute('data-default-text');
        }
      }
    });
    
    // Update header count if it exists
    const countBadge = document.querySelector('.js-wishlist-count');
    if (countBadge) {
      const count = this.getItems().length;
      countBadge.innerText = count;
      if (count > 0) {
        countBadge.classList.add('cart-link__bubble--visible');
      } else {
        countBadge.classList.remove('cart-link__bubble--visible');
      }
    }
  },
  
  initPage: function() {
    const container = document.getElementById('WishlistContainer');
    if (!container) return; // Not on the wishlist page
    
    const items = this.getItems();
    
    if (items.length === 0) {
      container.innerHTML = '<div class="grid__item text-center"><p>Your wishlist is currently empty.</p><a href="/collections/all" class="btn">Continue shopping</a></div>';
      return;
    }
    
    // Build the promises for fetching the card HTML
    const fetchPromises = items.map(handle => {
      // Shopify has an alternate template: view=card
      return fetch(`/products/${handle}?view=card`)
        .then(response => {
          if (!response.ok) throw new Error('Product not found');
          return response.text();
        })
        .catch(error => {
          // If a product was deleted, remove it from the wishlist
          this.removeItem(handle);
          return '';
        });
    });
    
    Promise.all(fetchPromises).then(htmlArray => {
      // Filter out empty responses and join
      const validHtml = htmlArray.filter(html => html.trim() !== '');
      if (validHtml.length === 0) {
         container.innerHTML = '<div class="grid__item text-center"><p>Your wishlist is currently empty.</p><a href="/collections/all" class="btn">Continue shopping</a></div>';
      } else {
         container.innerHTML = validHtml.join('');
         // Re-initialize buttons after injecting new HTML
         this.updateButtons();
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  Wishlist.updateButtons();
  Wishlist.initPage();
  
  // Delegate events for dynamically added buttons
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-wishlist-btn');
    if (!btn) return;
    
    e.preventDefault();
    const handle = btn.getAttribute('data-product-handle');
    if (handle) {
      Wishlist.toggleItem(handle);
      Wishlist.updateButtons();
      
      // If we are on the wishlist page and an item is removed, remove it from DOM
      const container = document.getElementById('WishlistContainer');
      if (container && !Wishlist.hasItem(handle)) {
        const gridItem = btn.closest('.grid__item');
        if (gridItem) {
           gridItem.remove();
           // Check if empty now
           if (container.querySelectorAll('.grid__item').length === 0) {
             container.innerHTML = '<div class="grid__item text-center"><p>Your wishlist is currently empty.</p><a href="/collections/all" class="btn">Continue shopping</a></div>';
           }
        }
      }
    }
  });
});
